import { cn } from '../../lib/cn';
import type { ReadinessCheckRow } from '../../customersuccess/framework';

type Props = { checks?: ReadinessCheckRow[] };

export function ProductionReadinessPanel({ checks = [] }: Props) {
  return (
    <div className="space-y-2">
      {checks.map((c) => (
        <div key={c.check} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{c.check}</p>
          <div className="shrink-0 text-right">
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              c.status === 'passed' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              'bg-error-50 text-error-700 dark:bg-error-950 dark:text-error-300',
            )}>
              {c.status}
            </span>
            <p className="mt-1 text-xs text-slate-500">{c.score}%</p>
          </div>
        </div>
      ))}
    </div>
  );
}
